import { FC } from 'react'
import {
    Bar,
    BarChart,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from 'recharts'

interface CustomBarChartProps {
    values: Array<any>
    children: any
    dataKeyBar: string
    dataKeyYAxis: string
}

const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) return text
    return text.substring(0, maxLength) + '...'
}

export const CustomBarChart: FC<CustomBarChartProps> = ({
    values,
    children,
    dataKeyBar,
    dataKeyYAxis
}) => {
    return (
        <ResponsiveContainer width="100%" height={500}>
            <BarChart data={values} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis
                    type="category"
                    padding={{ top: 20, bottom: 20 }}
                    dataKey={dataKeyYAxis}
                    fontWeight={500}
                    fontSize={'14px'}
                    stroke="#000"
                    strokeWidth={3}
                    paintOrder="stroke"
                    tickFormatter={value => truncateText(value, 12)}
                    width={100}
                    tickMargin={8}
                />
                <Tooltip content={children} />
                <Legend />
                <Bar dataKey={dataKeyBar} name=" " fill="#21437a" />
            </BarChart>
        </ResponsiveContainer>
    )
}
